export const getUniqueSpareParts = (variations: any) => {
    if (variations && variations.length > 0) {
        var arms: any = [];
        var addedColors: any = [];
        variations.map((variation: any) => {
            var colorSlug = variation.attributes.nodes.filter((attribute: any) => attribute.name === 'pa_color')[0].value;
            var size = variation.attributes.nodes.filter((attribute: any) => attribute.name === 'pa_size')[0].value;
            if (!addedColors.includes(colorSlug)) {
                arms.push(variation);
                addedColors.push(colorSlug);
            }
        });
        return arms;
    }
    return null;
}

export const getSparePartSlug = (productSlug: any) => {
    return productSlug.replace('-extra-small', '').replace('-small').replace('-medium', '').replace('-large', '');
}